export default {
    buildTextarea: function(address){
        let a = '';
        if (address.company_name){
            a+= address.company_name+'\n';
        }
        a+= address.first_name+' '+address.last_name+'\n';
        a+= address.street+' '+address.street_number+'\n';
        a+= address.zip_code+' '+address.city;
        return a;
    }
}
